var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "view-box fill-height" },
    [
      !_vm.currentChat.can_reply
        ? _c("banner", {
            attrs: {
              "color-scheme": "alert",
              "banner-message": _vm.replyWindowBannerMessage,
              "href-link": _vm.replyWindowLink,
              "href-link-text": _vm.replyWindowLinkText
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isATweet
        ? _c("banner", {
            attrs: {
              "color-scheme": "gray",
              "banner-message": _vm.tweetBannerText,
              "has-close-button": _vm.hasSelectedTweetId
            },
            on: { close: _vm.removeTweetSelection }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sidebar-toggle__wrap" },
        [
          _c("woot-button", {
            staticClass: "sidebar-toggle--button",
            attrs: {
              variant: "smooth",
              size: "tiny",
              "color-scheme": "secondary",
              icon: _vm.isRightOrLeftIcon
            },
            on: { click: _vm.onToggleContactPanel }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "conversation-panel" },
        [
          _c("transition", { attrs: { name: "slide-up" } }, [
            _c("li", { staticClass: "spinner--container" }, [
              _vm.shouldShowSpinner
                ? _c("span", { staticClass: "spinner message" })
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _vm._l(_vm.getReadMessages, function(message) {
            return _c("message", {
              key: message.id,
              staticClass: "message--read ph-no-capture",
              attrs: {
                data: message,
                "is-a-tweet": _vm.isATweet,
                "is-a-whatsapp-channel": _vm.isAWhatsAppChannel,
                "has-instagram-story": _vm.hasInstagramStory,
                "is-web-widget-inbox": _vm.isAWebWidgetInbox
              }
            })
          }),
          _vm._v(" "),
          _c(
            "li",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.unreadMessageCount != 0,
                  expression: "unreadMessageCount != 0"
                }
              ],
              staticClass: "unread--toast"
            },
            [
              _c("span", { staticClass: "text-uppercase" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.unreadMessageCount) +
                    "\n        " +
                    _vm._s(
                      _vm.unreadMessageCount > 1
                        ? _vm.$t("CONVERSATION.UNREAD_MESSAGES")
                        : _vm.$t("CONVERSATION.UNREAD_MESSAGE")
                    ) +
                    "\n      "
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.getUnReadMessages, function(message) {
            return _c("message", {
              key: message.id,
              staticClass: "message--unread ph-no-capture",
              attrs: {
                data: message,
                "is-a-tweet": _vm.isATweet,
                "is-a-whatsapp-channel": _vm.isAWhatsAppChannel,
                "has-instagram-story": _vm.hasInstagramStory,
                "is-web-widget-inbox": _vm.isAWebWidgetInbox
              }
            })
          })
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "conversation-footer",
          class: { "modal-mask": _vm.isPopoutReplyBox }
        },
        [
          _vm.isAnyoneTyping
            ? _c("div", { staticClass: "typing-indicator-wrap" }, [
                _c("div", { staticClass: "typing-indicator" }, [
                  _vm._v(
                    "\n        " + _vm._s(_vm.typingUserNames) + "\n        "
                  ),
                  _c("img", {
                    staticClass: "gif",
                    attrs: {
                      src: require("dashboard/assets/images/typing.gif"),
                      alt: "Someone is typing"
                    }
                  })
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("reply-box", {
            attrs: {
              "conversation-id": _vm.currentChat.id,
              "is-a-tweet": _vm.isATweet,
              "selected-tweet": _vm.selectedTweet,
              "popout-reply-box": _vm.isPopoutReplyBox
            },
            on: {
              "update:popoutReplyBox": function($event) {
                _vm.isPopoutReplyBox = $event
              },
              "update:popout-reply-box": function($event) {
                _vm.isPopoutReplyBox = $event
              },
              click: _vm.showPopoutReplyBox
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }